import { useFiltersV2Actions } from "PFApp/components/filters_v2";
import { useFiltersState } from "PFApp/components/filters_v2/hooks/use_filters_state";
import { Button } from "PFComponents/button";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

type FiltersV2ButtonProps = {
  target?: "side_panel" | "box";
  withLabel?: boolean;
  disabled?: boolean;
  qaId?: string;
  className?: string;
  style?: React.CSSProperties;
};

export const FiltersV2Button = ({
  target = "side_panel",
  withLabel,
  disabled,
  className,
  qaId,
  style
}: FiltersV2ButtonProps) => {
  const { t } = useTranslation("filters", { keyPrefix: "button" });
  const { areUserVisibleFiltersModified } = useFiltersState();
  const { toggleFiltersSidePanel } = useFiltersV2Actions();

  const handleClick =
    target === "side_panel"
      ? () => toggleFiltersSidePanel()
      : () => {
          // TODO: [SP-2905] open filters box
        };

  const id = `filters_${target}_button`;

  return (
    <Inline alignItems="center" style={style}>
      {withLabel && <Typography variant="bodyRegular">{t("label")}</Typography>}
      <Button
        aria-label={t("openFiltersPanel")}
        className={className}
        icon={areUserVisibleFiltersModified ? "filter-applied" : "filter"}
        kind="secondary"
        onClick={handleClick}
        id={id}
        disabled={disabled}
        qaId={qaId || id}
      />
    </Inline>
  );
};
